import { Link } from 'react-router-dom';

import { BaseDataRow } from 'shared/components/DataRow/components/DataRow/components/BaseDataRow';

import type { BoxProps } from '@mui/system';
import type { FC } from 'react';
import type { Target } from 'shared/types';

interface NavigationDataRowProps extends BoxProps {
  to: string;
  target?: Target;
}

export const NavigationDataRow: FC<NavigationDataRowProps> = ({
  sx,
  ...props
}) => (
  <BaseDataRow
    sx={{ textDecoration: 'none', ...sx }}
    component={Link}
    role="button"
    {...props}
  />
);
